import React from "react";
import { Link } from "react-router-dom";
// import "../../InstaDappLogo.png"


const InstaLogo = () => {
  return (
    <Link href="#" className="logo">
      
      <img src="https://cdn.freelogodesign.org/files/728c6f8103f5428cbeca2ff195c1dca1/thumb/logo_200x200.png?v=638301967340000000" alt="" />
      {/* https://cdn.freelogodesign.org/files/728c6f8103f5428cbeca2ff195c1dca1/thumb/logo_200x200.png?v=0 */}
      {/* https://cdn.freelogodesign.org/files/728c6f8103f5428cbeca2ff195c1dca1/thumb/logo_200x200.png?v=638301954830000000 */}
    </Link>
  );
};

export default InstaLogo;
